/**
 * Ferry route types and fallback stub.
 * Route data (including extras) is fetched from the ferry-routes-all edge function.
 */

import { toSlug } from './ferrySlug';

/** Optional curated about block for a samband (never auto-generated). */
export type FerryRouteAbout = {
  shortDescription?: string;
  practicalInfo?: string[];
};

export interface FerryRoute {
  /** Entur line ID (e.g. "BFO:Line:…"), from ferry-routes-all. Same ID outlook-generate filters on. */
  id?: string;
  from: string;
  to: string;
  fromLat: number;
  fromLon: number;
  toLat: number;
  toLon: number;
  slug: string;
  /** Legacy / edge About prose — prefer `about.shortDescription` when set. */
  description?: string;
  /** Structured optional about; omit entirely when empty. */
  about?: FerryRouteAbout;
  travelTimeMinutes?: number;
  carCapacity?: number;
  passengerCapacity?: number;
  rushHourTip?: string;
  paymentInfo?: string;
}

/** Resolved about prose for UI — never invents text. */
export function resolveRouteAboutText(route: Pick<FerryRoute, "description" | "about">): string | undefined {
  const short = route.about?.shortDescription?.trim();
  if (short) return short;
  const legacy = route.description?.trim();
  return legacy || undefined;
}

export function resolveRoutePracticalInfo(
  route: Pick<FerryRoute, "about">,
): string[] {
  const items = route.about?.practicalInfo;
  if (!items?.length) return [];
  return items.map((s) => s.trim()).filter(Boolean);
}

type RouteInput = Omit<FerryRoute, 'slug'>;

/** Fallback: returns empty array. Use ferry-routes-all edge function instead. */
export function getAllRoutes(): FerryRoute[] {
  return [];
}
